var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "faq",
              label: _vm.$t(_vm.title_faq),
              icon: "fal fa-question-circle"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            { staticClass: "q-px-md q-pb-xl q-mt-md", attrs: { name: "faq" } },
            [
              _c("div", { staticClass: "row gutter-sm" }, [
                _c(
                  "div",
                  { class: _vm.filterClass },
                  [
                    _c(
                      "q-list",
                      [
                        _c(
                          "q-collapsible",
                          {
                            staticClass: "filter",
                            attrs: {
                              icon: "fal fa-filter",
                              label: _vm.$t("filter"),
                              opened: !_vm.$q.platform.is.mobile ? true : false
                            }
                          },
                          [
                            _c(
                              "q-list",
                              { attrs: { "no-border": "" } },
                              [
                                _c(
                                  "q-item",
                                  [
                                    _c(
                                      "q-item-main",
                                      [
                                        _c("q-search", {
                                          attrs: {
                                            placeholder: _vm.$t("search"),
                                            icon: "fal fa-search",
                                            debounce: 500
                                          },
                                          model: {
                                            value: _vm.search,
                                            callback: function($$v) {
                                              _vm.search = $$v
                                            },
                                            expression: "search"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                ),
                                _c(
                                  "q-item",
                                  [
                                    _c(
                                      "q-item-main",
                                      [
                                        _c("p", { staticClass: "caption" }, [
                                          _vm._v(_vm._s(_vm.$t("category")))
                                        ]),
                                        _c("q-btn-toggle", {
                                          staticClass:
                                            "full-width q-mb-sm progress",
                                          attrs: {
                                            "toggle-color": "primary",
                                            options: [
                                              {
                                                label: _vm.$t("all"),
                                                value: "all"
                                              }
                                            ]
                                          },
                                          model: {
                                            value: _vm.category,
                                            callback: function($$v) {
                                              _vm.category = $$v
                                            },
                                            expression: "category"
                                          }
                                        }),
                                        _vm._l(_vm.categories, function(
                                          cat,
                                          index
                                        ) {
                                          return _c("q-btn-toggle", {
                                            key: index,
                                            staticClass:
                                              "full-width q-mb-sm progress",
                                            attrs: {
                                              "toggle-color": "primary",
                                              options: [
                                                {
                                                  label: cat.title,
                                                  value: cat.id
                                                }
                                              ]
                                            },
                                            model: {
                                              value: _vm.category,
                                              callback: function($$v) {
                                                _vm.category = $$v
                                              },
                                              expression: "category"
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c("div", { class: _vm.contentClass }, [
                  _c("div", { staticClass: "row gutter-md" }, [
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "q-alert",
                          {
                            staticClass: "cursor-pointer",
                            attrs: { color: "info", icon: "cloud" },
                            nativeOn: {
                              click: function($event) {
                                return _vm.$router.push({ name: "help" })
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                                " +
                                _vm._s(
                                  _vm.$t(
                                    "did_not_find_an_answer_send_your_question"
                                  )
                                ) +
                                " " +
                                _vm._s(_vm.$t("here")) +
                                "\n                            "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _c(
                      "div",
                      { staticClass: "col-12" },
                      [
                        _c(
                          "q-list",
                          { attrs: { separator: "", sparse: "" } },
                          [
                            _vm._l(_vm.filteredQuestions, function(
                              question,
                              index
                            ) {
                              return _c(
                                "q-collapsible",
                                {
                                  key: index,
                                  attrs: {
                                    label: question.question,
                                    sublabel: _vm.getCategory(
                                      question.faq_category
                                    ),
                                    group: "faq",
                                    opened:
                                      _vm.collapsed === question.id
                                        ? true
                                        : false
                                  }
                                },
                                [
                                  _c("blockquote", [
                                    _vm._v(
                                      "\n                                        " +
                                        _vm._s(question.faq_question_answer) +
                                        "\n                                    "
                                    )
                                  ])
                                ]
                              )
                            }),
                            _vm.filteredQuestions.length === 0
                              ? _c("q-collapsible", {
                                  attrs: {
                                    label: _vm.$t("no_questions_found"),
                                    group: "faq",
                                    disable: ""
                                  }
                                })
                              : _vm._e()
                          ],
                          2
                        )
                      ],
                      1
                    )
                  ])
                ])
              ])
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }